import React, { Suspense } from "react";

const Tenantlogin = React.lazy(() => import('./subpages/Tenantlogincontent.jsx'));

class Ptenantlogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            AlterpopId: "alertModel",


        };
    }
    redirecttohome() {
        this.props.history.push("/tenantprofile");
    }

    render() {
        return (
            <Suspense fallback={<div></div>}>
                <Tenantlogin OnSuccess={this.redirecttohome.bind(this)} />
            </Suspense>
        );
    }
}
export default Ptenantlogin;